module.exports = {
	TEXT_PLAIN: 'text/plain',
	XML: 'text/xml',
	JSON: 'application/json',
};
